module.exports = __webpack_public_path__ + "static/media/search.5f9e0f82.svg";